import React, { ReactElement } from 'react';
import {
  Col, Row, Text,
} from 'idsk-react-components';
import './pouzivatelskePriruckyMobileTableItem.scss';

interface Props {
  nazovRiadokPrvy: string,
  nazovRiadokDruhy: string,
  hodnotaRiadokPrvy: string,
  hodnotaRiadokDruhy: string,
  actions: ReactElement,
}

const PouzivatelskePriruckyMobileTableItem = ({
  nazovRiadokPrvy,
  nazovRiadokDruhy,
  hodnotaRiadokPrvy,
  hodnotaRiadokDruhy,
  actions,
}: Props): ReactElement => (
  <Col className="dokument-detail">
    <Row className="dokument-detail-row">
      <div className="one-quarter">
        <Text type="span" className="information-header">
          {nazovRiadokPrvy}
        </Text>
      </div>
      <div className="three-quarters">
        <Text type="p" className="dokument-detail-row-text">{hodnotaRiadokPrvy}</Text>
      </div>
    </Row>
    <Row className="dokument-detail-row">
      <div className="one-quarter">
        <Text type="span" className="information-header">
          {nazovRiadokDruhy}
        </Text>
      </div>
      <div className="three-quarters">
        <Text type="p" className="dokument-detail-row-text">{hodnotaRiadokDruhy}</Text>
      </div>
    </Row>
    <Row className="dokument-detail-row">
      {actions}
    </Row>
  </Col>
);

export default PouzivatelskePriruckyMobileTableItem;
